import ScaledCard from "./ScaledCard";

export default function Thumbnails({ items, selected, onSelect }) {
  return (
    <nav className="st-thumbs" data-testid="thumbnail-strip">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={() => onSelect(item.key)}
          className={`st-thumb ${selected === item.key ? "is-active" : ""} ${item.excluded ? "is-excluded" : ""}`}
          data-testid={`thumb-${item.key}`}
        >
          <ScaledCard width={132}>{item.render(item.refCb)}</ScaledCard>
          <span className="st-thumb-label">
            {item.label}
            {item.missingPhoto && <i className="st-dot" title="Fără poză" />}
          </span>
        </button>
      ))}
    </nav>
  );
}
